import { Drawer } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React, { FC } from 'react';
import { BiX } from 'react-icons/bi';

import { montserrat } from '@/components/Layout';
import { ISourceDocuments } from '@/components/ZAIChatLayout/ChatMessages';
import BookCard from '@/components/ZAIChatLayout/SourceDrawer/BookCard';

interface Props {
  onClose?:
    | ((
        e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>,
      ) => void)
    | undefined;
  open?: boolean | undefined;
  sourceDocumentsToDisplay: ISourceDocuments[];
}

const SourceDrawer: FC<Props> = ({
  onClose,
  open,
  sourceDocumentsToDisplay,
}) => {
  const screens = useBreakpoint();
  return (
    <Drawer
      closable={false}
      placement={screens.md ? 'right' : 'bottom'}
      onClose={onClose}
      open={open}
      key='Source Drawer'
      classNames={{
        mask: '',
        body: 'flex',
        wrapper: '',
        content: 'bg-grayZl-925 border-l border-grayZl-900 ',
      }}
      styles={{
        wrapper: {
          fontFamily: montserrat.style.fontFamily,
        },
      }}
      height='60vh'
    >
      <div className='flex flex-col flex-1'>
        <div className='flex items-center justify-between md:p-[18px] p-[22px] border-b border-grayZl-900'>
          <p className='md:text-xl text-lg text-white font-medium md:leading-7 leading-[100%]'>
            Sources
          </p>
          <BiX onClick={onClose} className='md:h-7 h-5 md:w-7 w-5' />
        </div>
        <div className='py-[18px] flex flex-col gap-[18px] zai-scrollbar flex-1 overflow-auto'>
          {sourceDocumentsToDisplay?.map((sourceDocument) => (
            <BookCard
              sourceDocument={sourceDocument}
              key={sourceDocument.citation_id}
            />
          ))}
        </div>
      </div>
    </Drawer>
  );
};

export default SourceDrawer;
